import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Box } from '@marvelapp/ui';
import * as handoffItems from '../../constants/handoffItems';
import { WIDTH } from '../../constants/handoffSidebar';
import ArtboardHandoff from '../../containers/handoff/ArtboardHandoff';
import ElementHandoff from './ElementHandoff';
export default function SidebarHandoff(_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onClose = _a.onClose, _c = _a.selectedElementType, selectedElementType = _c === void 0 ? handoffItems.DEFAULT : _c;
    return (React.createElement(SidebarHandoffWrap, { color: "slate", fontFamily: 0, translate: isOpen ? 0 : WIDTH, width: WIDTH }, isOpen &&
        (selectedElementType === 'default' ? (React.createElement(ArtboardHandoff, { onClose: onClose })) : (React.createElement(ElementHandoff, { selectedElementType: selectedElementType })))));
}
var SidebarHandoffWrap = styled(Box).attrs({
    bg: 'white',
    transition: 'smooth.fast',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  overflow: scroll;\n  letter-spacing: -0.2px;\n  transform: translateX(", "px);\n  box-shadow: -1px 0 1px rgba(0, 0, 0, 0.07);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  overflow: scroll;\n  letter-spacing: -0.2px;\n  transform: translateX(", "px);\n  box-shadow: -1px 0 1px rgba(0, 0, 0, 0.07);\n"])), function (props) { return props.translate; });
var templateObject_1;
